<script>
    export let autofocus = null;
    export let value = '';
    export let label = '';
    export let type = 'text';
    export let required = false;
    export let error = null;

    let dateValue = value;

    if (type === 'date' && value) {
        dateValue = new Date(value);
        dateValue = dateValue.toISOString().split('T')[0];
    }

    function onDateChange() {
        value = dateValue;
    }
</script>
<div class="form-group {error? 'input-invalid': ''}">
    {#if type !== "checkbox"}
        <label>
            {@html label}
            {#if required}
                <i><small class="text-muted">*</small></i>
            {/if}
        </label>
    {/if}
    {#if type === "text"}
        <input class="form-control" type="text" bind:value={value} {required} {autofocus} >
    {/if}
    {#if type === "password"}
        <input class="form-control" type="password" bind:value={value} {required} {autofocus} >
    {/if}
    {#if type === "phone"}
        <input class="form-control" type="phone" bind:value={value} {required} {autofocus} >
    {/if}
    {#if type === "date"}
        <input class="form-control" type="date" bind:value={dateValue} {required} {autofocus} on:change={onDateChange}>
    {/if}
    {#if type === "email"}
        <input class="form-control" type="email" bind:value={value} {required} {autofocus} >
    {/if}
    {#if type === "file"}
        <input class="form-control" type="file" bind:value={value} {required} style="width: 100%;" >
    {/if}
    {#if type === "checkbox"}
        <label>
            <input class="form-control" type="checkbox" bind:value={value} {required} {autofocus} >
            {@html label}
            {#if required}
                <i><small class="text-muted">*</small></i>
            {/if}
        </label>
    {/if}
    {#if error}
        <output><small class="text-danger">{error}</small></output>
    {/if}
</div>
